export default "__VITE_ASSET__f032b65b__"